export const ScenarioTypeEnum = {
    LIMITED_VISITS: "visits",
    LIMITED_TIME: "time",
    LIMITED_ACCESS: "access",
    CONTRACT: "contract",
    MANY: "many"
};